import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { cleanRoom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useAddUserToCleanRoom = () => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();

  return useMutation(
    async (
      { crId, users },
    ) => axiosInstance.post(cleanRoom(orgId).addCrUsers(crId), {
      users,
    }),
    {
      onSuccess: () => {
        dispatch(showAlert({
          message: 'Successfully added user(s) to the clean room',
          type: 'success',
        }));
      },
      onError: (err) => {
        dispatch(showAlert({
          message: err.response.data.message,
          type: 'error',
        }));
      },
    },
  );
};
